import { NETWORK } from "src/config/constants";
import { ethers } from "ethers";
import { convertBigNumber } from "src/ether-utils/utils";
import Bep20Abi from "src/assets/abis/Bep20Abi.json";

export const TravaPriceConfig = {
  [NETWORK.BSC_MAINNET]: {
    travaAddress: "0x0391be54e72f7e001f6bbc331777710b4f2999ef",
    travaLPAddress: "0x865c77d4Ff6383E06c58350a2cfb95cCA2c0F056", // TRAVA-WBNB LP address
    secondAddress: "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c", // WBNB address
    secondLPAddress: "0x16b9a82891338f9bA80E2D6970FddA79D1eb0daE", // WBNB-USDT LP address
    stableAddress: "0x55d398326f99059ff775485246999027b3197955", // USDT BSC address
  },
  [NETWORK.FTM_MAINNET]: {
    travaAddress: "0x477a9d5df9beda06f6b021136a2efe7be242fcc9",
    travaLPAddress: "0x7af19103e0ecf20acd414d365b1d966c58fe3799", // TRAVA-WFTM LP address
    secondAddress: "0x21be370d5312f44cb42ce377bc9b8a0cef1a4c83", // WFTM address
    secondLPAddress: "0x5965e53aa80a0bcf1cd6dbdd72e6a9b2aa047410", // WFTM-USDT LP address
    stableAddress: "0x049d68029688eabf473097a2fc38ef61633a3c7a", // USDT FTM address
  },
  [NETWORK.ETH_MAINNET]: {
    travaAddress: "0x186d0ba3dfc3386c464eecd96a61fbb1e2da00bf",
    travaLPAddress: "0xc1969d3deee81206e43e95b26b98da3d08940055", // TRAVA-WETH LP address
    secondAddress: "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2", // WETH address
    secondLPAddress: "0x0d4a11d5eeaac28ec3f61d100daf4d40471f1852", // WETH-USDT LP address
    stableAddress: "0xdac17f958d2ee523a2206206994597c13d831ec7", // USDT ETH address
  },
};

export default class TravaPriceFetcher {
  constructor(provider, network) {
    this.provider = provider;
    this.network = network;
    if (network == NETWORK.BSC_TESTNET) {
      this.provider = new ethers.providers.JsonRpcProvider("https://bsc-dataseed2.defibit.io");
      this.travaAddress = TravaPriceConfig[NETWORK.BSC_MAINNET].travaAddress;
      this.travaLPAddress = TravaPriceConfig[NETWORK.BSC_MAINNET].travaLPAddress;
      this.secondAddress = TravaPriceConfig[NETWORK.BSC_MAINNET].secondAddress;
      this.secondLPAddress = TravaPriceConfig[NETWORK.BSC_MAINNET].secondLPAddress;
      this.stableAddress = TravaPriceConfig[NETWORK.BSC_MAINNET].stableAddress;
    } else {
      this.travaAddress = TravaPriceConfig[network].travaAddress;
      this.travaLPAddress = TravaPriceConfig[network].travaLPAddress;
      this.secondAddress = TravaPriceConfig[network].secondAddress;
      this.secondLPAddress = TravaPriceConfig[network].secondLPAddress;
      this.stableAddress = TravaPriceConfig[network].stableAddress;
    }

    this._travaContract = new ethers.Contract(this.travaAddress, Bep20Abi, provider);
    this._secondContract = new ethers.Contract(this.secondAddress, Bep20Abi, provider);
    this._stableContract = new ethers.Contract(this.stableAddress, Bep20Abi, provider);

    this.getTravaPrice = this.getTravaPrice.bind(this);
  }

  async getTravaPrice() {
    if (this.network == NETWORK.BSC_TESTNET) return 1;
    let [
      travaLPBalance,
      travaDecimal,
      secondTravaLPBalance,
      secondLPBalance,
      secondDecimal,
      stableBalance,
      stableDecimal,
    ] = await Promise.all([
      this._travaContract.balanceOf(this.travaLPAddress),
      this._travaContract.decimals(),
      this._secondContract.balanceOf(this.travaLPAddress),
      this._secondContract.balanceOf(this.secondLPAddress),
      this._secondContract.decimals(),
      this._stableContract.balanceOf(this.secondLPAddress),
      this._stableContract.decimals(),
    ]);
    travaLPBalance = convertBigNumber(travaLPBalance, travaDecimal, 10);
    secondTravaLPBalance = convertBigNumber(secondTravaLPBalance, secondDecimal, 10);
    secondLPBalance = convertBigNumber(secondLPBalance, secondDecimal, 10);
    stableBalance = convertBigNumber(stableBalance, stableDecimal, 2);
    return (secondTravaLPBalance / travaLPBalance) * (stableBalance / secondLPBalance);
  }
}
